import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

import { Constants } from '../constants/constants';
import { SplunkService } from '../services/splunk.service';
import { LogEventOptions } from '../models/log-events-options.model';
import { UserService } from '../../core/services/user.service';
import { UtilityService } from './utility.service';

@Injectable()
export class LoggerService {
  info: any;
  warn: any;
  error: any;
  timestamp: any;

  constructor(
    private userService: UserService,
    private splunkService: SplunkService,
    private utilities: UtilityService
  ) { }

  logEvent(
    eventCd: string,
    eventDesc: string,
    eventId: string,
    userId?: string,
    options?: LogEventOptions,
    eventStatus?: string,
    portal?: string
  ) {
    const request = {
      _time: formatDate(new Date(), 'yyyy-MM-d hh:mm:ss.SSS', 'en-US'),
      cstntTypCd: Constants.APPLICATION_AUDIT,
      sessionId: this.userService.getSessionID,
      ipAddress: this.userService.getIpAddress,
      userIdentifier: userId,
      eventDescription: eventDesc,
      eventCode: eventCd,
      eventId: eventId,
      eventStatus: eventStatus,
      transactionId: this.utilities.getTransactionID(),
      userBrowser: this.userService.getCurrentBrowser(),
      ...(portal && { portal: portal }),
      detailedLog: {
        ...options
      }
    };
    this.splunkService.logEventToSplunk(request).subscribe();
  }

}
